// import { i18n } from '@shared/i18n';
import { TeamService } from '@modules/team/team-service';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import { routerAsync } from '@/app-module';

export default {
  namespaced: true,

  state: {
    saveLoading: false
  },

  getters: {
    saveLoading: state => state.saveLoading
  },

  mutations: {
    SUBMIT_STARTED(state) {
      state.saveLoading = true;
    },

    SUBMIT_SUCCESS(state) {
      state.saveLoading = false;
    },

    SUBMIT_ERROR(state) {
      state.saveLoading = false;
    },
  },

  actions: {
    async doAssignSchoolToTeam({commit}, { teamId, school, manage }) {      
      try {
        commit('SUBMIT_STARTED');
        await TeamService.assignSchoolToTeam(teamId, school, manage);

        commit('SUBMIT_SUCCESS');
        Message.success(i18n('entities.team.create.success'));
        
        // Go back
        routerAsync().go(-1);
      } catch (error) {
        Message.error(error.msg);
        commit('SUBMIT_ERROR');
      }
    }
  }
};